import WOD_COMBINATIONS from './wod-combinations';
import WOD_DIFFICULTY_GRADES from './wod-difficulty-grades';

export default (excercises, difficultyLevels) => {

    /*
    |--------------------------------------------------------------------------
    | General Difficulty level calculation
    |--------------------------------------------------------------------------
    */
    const difficulty = Object.keys(excercises)
        .reduce(
            (res, curr) => {
                res.min += (excercises[curr].min * excercises[curr].difficulty);
                res.max += (excercises[curr].max * excercises[curr].difficulty);
                return res;
            },
            {min: 0, max: 0}
        );

    difficulty.min *= 2 * (4 / 14) * 1.2;
    difficulty.max *= 6 * (10 / 14) * 0.8;

    function createDifficultyRange(difficultyLevel, difficulty, nrOfLevels) {
        const step = ((difficulty.max - difficulty.min) / (nrOfLevels - 1));
        return {
            min: difficultyLevel * step,
            max: ((difficultyLevel + 1) * (step)) - 1,
        }
    }

    const difficultyLevelsWithRanges = difficultyLevels.map(
        (level, index) => {
            return Object.assign(level, createDifficultyRange(index, difficulty, difficultyLevels.length));
        }
    );

    return {
        getExercises,
        getDifficultyLevels,
        getRandomWorkout,
    };

    function getExercises() {
        return excercises;
    }

    function getDifficultyLevels() {
        return difficultyLevelsWithRanges;
    }

    function randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function getRandomWorkout() {
        const rounds = randomInt(2, 6);
        const nrOfExercises = randomInt(4, 10);
        const workoutRoutine = {
            exercises: [],
            difficulty: null,
            rounds,
        };

        const exercises = getExercises();
        const exerciseNames = Object.keys(exercises);
        for (let i = 0; i < nrOfExercises; i++) {
            const randomExcerciseName = exerciseNames.splice(Math.floor(Math.random() * exerciseNames.length), 1)[0];
            const randomExercise = exercises[randomExcerciseName];
            const roundNumbers = randomInt(
                randomExercise.min,
                randomExercise.max
            );
            const rounds = Math.ceil(roundNumbers / randomExercise.pass) * randomExercise.pass;

            workoutRoutine.exercises.push({
                rounds: rounds,
                name: randomExcerciseName,
                difficulty: randomExercise.difficulty
            });
        }

        workoutRoutine.difficulty = calculateWorkoutDifficulty(
            workoutRoutine.exercises,
            workoutRoutine.rounds
        );

        return workoutRoutine;
    }

    function calculateWorkoutDifficulty(exercises, rounds) {
        const singleRoundDifficulty = exercises.reduce((res, exercise) => {
            res += exercise.difficulty * exercise.rounds;
            return res;
        }, 0);

        const setDifficulty = rounds * singleRoundDifficulty;

        const difficultyGrades = getDifficultyLevels();
        const minDifficulty = Math.min.apply(null, difficultyGrades.map(x => x.min));
        const maxDifficulty = Math.max.apply(null, difficultyGrades.map(x => x.max));

        const difficultyLevel = difficultyGrades.filter((item) => {
            return setDifficulty >= item.min && setDifficulty <= item.max
        });

        if (difficultyLevel.length === 1) {
            return difficultyLevel[0];
        }

        if (setDifficulty <= minDifficulty) {
            return difficultyGrades.filter((item) => item.min === minDifficulty)[0];
        }

        if (setDifficulty >= maxDifficulty) {
            return difficultyGrades.filter((item) => item.max === maxDifficulty)[0];
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/wod-calculations.js